import storage from '@/utils/storage'

const TEXT_SEARCH_HISTORY_KEY = 'bestdealer-text-search-history'

export const useTextSearch = () => {
  const insertTextSerachRecord = (record) => {
    const textSearchHistory = storage.get(TEXT_SEARCH_HISTORY_KEY) ?? []
    if (textSearchHistory.includes(record)) return
    textSearchHistory.push(record)
    if (textSearchHistory.length > 3) {
      textSearchHistory.shift()
    }
    storage.set(TEXT_SEARCH_HISTORY_KEY, textSearchHistory)
  }

  const getTextSearchHistory = () => {
    return storage.get(TEXT_SEARCH_HISTORY_KEY) ?? []
  }

  return { getTextSearchHistory, insertTextSerachRecord }
}
